<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

var stopLoading = function () {
  var element = document.getElementById("o2_loading");
  element.parentNode.removeChild(element);
}

export default {
  name: 'App',
  mounted(){
    (function() {
      let hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?833be5ac9686bb7b57b1c34a6dbb91d6";
      let s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }
}
</script>

<style lang="scss">
  * {
    -webkit-tap-highlight-color: transparent;
    outline: 0;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
    max-height:99999px;
  }

  body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td {
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }

  img {
    border: 0 none;
    vertical-align: top;
  }

  i, em {
    font-style: normal;
  }

  ol, ul {
    list-style: none;
  }

  input, select, button, h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
    font-family: inherit;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    text-decoration: none;
    color: #666;
  }

  body {
    margin: 0 auto;
    min-width: 320px;
    max-width: 768px;
    width: 100%;
    height: 100%;
    font-size: 14px;
    font-family: -apple-system, Helvetica, "Microsoft YaHei", Arial, sans-serif;
    line-height: 1.5;
    color: #666;
    text-size-adjust: 100% !important;
    user-select: none;
  }

  input[type="text"], textarea {
    appearance: none;
  }

  html,#app {
    width: 100%;
    height: 100%;
  }

  .hide {
    display: none !important;
  }

  .clear {
    clear: both;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .loading-mask{
    display:flex;
    flex-direction: column;
    align-items: center;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index:99999;
    background-color:#FFFFFF;
    img{
      margin-top: 440px;
      width:144px;
      height:144px;
    }
    span{
      margin-top: 16px;
      font-size: 28px;
      color: #C4C0C0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue